import { FormControl, FormErrorMessage, FormHelperText, FormLabel } from "@chakra-ui/react";
import { Control, Controller, FieldPath, FieldValues, useWatch } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { MinimalOrgDto, OrganizationType } from "../../../autogen/bff-api";
import { OrganizationSelector } from "../../organization/OrganizationSelector";

interface Props<T extends FieldValues> {
  label: string;
  helperText: string;
  control: Control<T>;
  name: FieldPath<T>;
  orgsToExclude?: string[];
  type?: OrganizationType;
  required?: {
    value: boolean;
    message: string;
  };
  errorMessage?: string;
}

export const OrganizationFormSelector = <T extends FieldValues>({
  control,
  helperText,
  name,
  label,
  type,
  orgsToExclude,
  required,
  errorMessage,
}: Props<T>) => {
  const { t } = useTranslation();
  const selectedOrganization = useWatch({ control, name });
  return (
    <FormControl isInvalid={errorMessage !== undefined}>
      <FormLabel htmlFor={name}>{label}</FormLabel>
      <Controller
        control={control}
        name={name}
        rules={{ required }}
        render={({ field: { onChange, value } }) => (
          <OrganizationSelector
            type={type}
            placeholder={t("Select an organization") ?? ""}
            organization={value as MinimalOrgDto | undefined}
            orgsToExclude={orgsToExclude}
            onChange={(value) => {
              onChange(value.organization);
            }}
          />
        )}
      />
      {!selectedOrganization && errorMessage === undefined && <FormHelperText>{helperText}</FormHelperText>}
      <FormErrorMessage>{errorMessage}</FormErrorMessage>
    </FormControl>
  );
};
